import React from 'react';
import StaticPage from './StaticPage';

export default function Refund() {
  return (
    <StaticPage
      title="Refund Policy"
      subtitle="Prescription products are final sale. If we made an error filling your prescription, we'll make it right."
      seoDescription="ALFA MEDS & CO LLC Refund Policy — prescription products are final sale. Contact help@alfameds.com for prescription-fill errors."
    >
      <h2>Refund Policy</h2>
      <p>
        Unfortunately we cannot accept returns of prescription products for reuse or resale, and all sales are final.
        However, if you feel we have made an error in the filling of your prescription, please contact us at{' '}
        <a className="underline" href="mailto:help@alfameds.com">help@alfameds.com</a>.
      </p>

      <h2>Contact</h2>
      <p>
        ALFA MEDS &amp; CO LLC<br />
        <a className="underline" href="https://alfameds.com/">https://alfameds.com/</a><br />
        <a className="underline" href="mailto:help@alfameds.com">help@alfameds.com</a><br />
        <a className="underline" href="tel:+19419489940">(941) 948-9940</a><br />
        6868 Wild Lake Terrace, Bradenton, FL, 34212
      </p>
    </StaticPage>
  );
}
